import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Sapfioritemplate extends Component {
 
  render() {
    const course =[
      {
        title : " Introduction to SAP Fiori",
        content: [
        "Overview of SAP Fiori",
        "SAP Fiori architecture and components",
        "Fiori Launchpad and Fiori Apps",
        "Fiori Implementation Options"
        ]
        },
        {
        title : " SAP Fiori Design Principles",
        content: [
        "SAP Fiori design guidelines and principles",
        "Role-based and task-based design concepts",
        "Responsive design and Fiori user experience (UX)",
        "Design thinking approach for Fiori UX"
        ]
        },
        {
        title : " SAPUI5 and OData Services",
        content: [
        "Introduction to SAPUI5 framework",
        "Basics of HTML5, CSS3, and JavaScript",
        "Model-View-Controller (MVC) architecture",
        "Introduction to OData services for Fiori apps"
        ]
        },
        {
        title : " Fiori App Types and Floorplans",
        content: [
        "Introduction to Fiori app types",
        "Transactional, Analytical, and Fact Sheet apps",
        "Overview of Fiori floorplans (Overview Page, List Report, Object Page)",
        "Fiori elements and Smart Controls"
        ]
        },
        {
        title : " Fiori Launchpad Configuration and Administration",
        content: [
        "Fiori Launchpad architecture and components",
        "Configuration of Launchpad roles and catalogs",
        "Tiles, groups, and target mapping",
        "Launchpad personalization and theming",
        "Fiori Launchpad administration and monitoring"
        ]
        },
        {
        title : " SAP Fiori Implementation and Deployment",
        content: [
        "Preparing the system landscape for Fiori implementation",
        "Installation and configuration of Fiori Front-end Server",
        "Configuration of Fiori Back-end Server",
        "OData service provisioning and activation",
        "Deployment and activation of Fiori apps"
        ]
        },
        {
        title : " SAP Fiori Security and Authorization",
        content: [
        "Fiori security concepts and principles",
        "Role-based access control (RBAC)",
        "Authorization objects and roles for Fiori",
        "User and role management in Fiori",
        "Fiori Launchpad security configuration"
        ]
        },
        {
        title : " Fiori App Extensibility and Customization",
        content: [
        "Extending standard Fiori apps using SAP Web IDE",
        "Customizing Fiori Launchpad and theme",
        "Enhancing Fiori apps with UI annotations",
        "Developing custom Fiori apps using SAPUI5",
        "Overview of SAP Fiori elements extensions"
        ]
        },
        {
        title : " SAP Fiori for S/4HANA",
        content: [
        "Introduction to Fiori for S/4HANA",
        "Fiori apps for S/4HANA modules (Finance, Logistics, HR, etc.)",
        "Embedded analytics and Smart Business tiles in Fiori",
        "Integration of Fiori with S/4HANA"
        ]
        },
        {
        title : " SAP Fiori Mobile Apps",
        content: [
        "Introduction to Fiori mobile apps",
        "Mobile app architectures and deployment options",
        "Developing hybrid mobile apps with SAP Web IDE",
        "Mobile security and management for Fiori apps"
        ]
        }
    ]

 
    const faqData = [
      {
        question: 'What is SAP Fiori Training?',
        answer:
          'SAP Fiori Training is a specialized program designed to equip individuals with the skills and knowledge needed to develop, customize, and implement Fiori applications within the SAP ecosystem',
      },
      {
        question: 'Why is SAP Fiori Training important?',
        answer:
          'SAP Fiori Training is essential for professionals seeking to enhance user experience and productivity by leveraging Fiori apps, enabling them to streamline business processes and improve user satisfaction',
      },
      {
        question: 'Who can benefit from SAP Fiori Training at the best training centre?',
        answer:
          'Training at the best training centre is suitable for SAP consultants, developers, UI/UX designers, and anyone interested in mastering Fiori app development and customization.',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with SAP Fiori skills can pursue various career opportunities such as SAP Fiori Developer, SAP UI5 Developer, Fiori Application Consultant, SAP Fiori Architect, and Fiori UX Designer.',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into SAP Fiori at the Best Training Centre. Our comprehensive program warmly welcomes individuals from diverse backgrounds, offering them the opportunity to acquire the skills and knowledge necessary to thrive in the realm of SAP Fiori application development and user experience design. Whether you're an IT professional, a developer, or a business analyst, our courses cater to learners at every level of expertise. With a strong emphasis on practical application and hands-on learning, our expert instructors guide you through essential SAP Fiori concepts, including UI design principles, app development, and integration with SAP systems. At the Best Training Centre, we prioritize inclusivity and accessibility, ensuring that learners of all backgrounds have the opportunity to excel in mastering SAP Fiori with the best training centre. Join us and unlock your potential in SAP Fiori at the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Deepa",
          date:" Jan 09 ,2023",
          review:` learnsoft.org offers specialized SAP FIORI training programs designed to equip you with the skills and knowledge needed to excel in UX design. These programs are conducted online, providing you with the flexibility to learn at your own place.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Bhaskar",
          date:" Jan 29 ,2023",
          review:" learnsoft.org's SAP FIORI training is your gateway to mastering user-centric design and creating exceptional user experiences. It's an investment in your future, opening doors to a fulfilling career in UX design."
      },
  ]
    
    return(
      <>
      
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the fast-evolving landscape of enterprise applications, user experience is paramount. Enter SAP Fiori, a revolutionary user experience (UX) and design concept meticulously developed by SAP. Its mission? To transform the user interface (UI) of SAP applications into a modern, intuitive, and user-friendly platform. SAP Fiori presents a curated collection of role-based, responsive, and personalized applications, enabling users to seamlessly engage with SAP systems across a spectrum of devices, including desktops, tablets, and smartphones. "/> */}
           
          <NewMainsec rating='4.3' students={"388"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the fast-evolving landscape of enterprise applications, user experience is paramount. Enter SAP Fiori, a revolutionary user experience (UX) and design concept meticulously developed by SAP. Its mission? To transform the user interface (UI) of SAP applications into a modern, intuitive, and user-friendly platform. SAP Fiori presents a curated collection of role-based, responsive, and personalized applications, enabling users to seamlessly engage with SAP systems across a spectrum of devices, including desktops, tablets, and smartphones. "/>

            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		        <Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`SAP Fiori Training is a comprehensive course designed to provide participants with the knowledge and skills to effectively design, develop, and deploy modern, user-friendly SAP Fiori applications. SAP Fiori is a collection of user interfaces and applications that offer a responsive and intuitive user experience for SAP systems. This training aims to equip learners with the expertise to design beautiful and user-centric Fiori apps that leverage SAP's latest technology and design principles.`} 
            title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our SAP Fiori course covers the design principles, architecture, and development of Fiori apps for SAP systems. Topics include Fiori design guidelines, SAPUI5 framework, OData services, app deployment, and responsive design. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in SAP Fiori. By the end of the course, you will be able to implement SAP Fiori practices in your own projects."}/>
		      </section>
          <Batchtime title={this.props.title} fees="39,999" offer="34,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
 <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
        <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou2="SAP BASIS" coupath2="sap-basis" cou='SAP FICO' coupath='sap-fico' cou9='SAP SD' coupath9='sap-sd' cou6='SAP MM' coupath6='sap-mm' cou10='SAP BI' coupath10='sap-bi'
          cou5='SAP MDG' coupath5='sap-mdg' cou3='SAP ABAP' coupath3='sap-abap' cou7='SAP HR' coupath7='sap-hr'
          cou1='SAP SCM' coupath1='sap-scm' cou8='SAP PP' coupath8='sap-pp'  cou4='SAP S4 HANA' coupath4='sap-s4-hana' />

        
      </>
    );
  }
}
